<icc-list [searchable]="true" [items]="drives"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (showInfo)="showInfo($event)"
          [selected]="selectedDriveId"
          (select)="selectDrive($event)"></icc-list>
